export const INDENT_EM_PER_LEVEL = 1.677777;

export const INDENT_ATTRS = {
  indentLevel: 'level',
  hanging: 'hanging',
} as const;

export const INDENT_FLAG_ATTR = 'indent';

export const LABEL_BOX_ATTR = 'data-label-box';

export const ORDERED_LIST_ATTRS = {
  start: 'start',
  type: 'type',
  presetType: 'pre-set-type',
  depth: 'indent',
  markerFormat: 'data-marker',
  textOffset: 'text-offset',
} as const;

export const LIST_ITEM_ATTRS = {
  markerSize: 'data-marker-size',
  markerColor: 'data-marker-color',
  markerBold: 'data-marker-bold',
  markerItalic: 'data-marker-italic',
  markerUnderline: 'data-marker-underline',
} as const;

export const LINE_SLOT_ATTR = 'line-slot';

export const PARAGRAPH_ATTRS = {
  fontSize: 'data-font-size',
} as const;

export const BODY_FONT_PT = 9;

export const MAX_HEADING_LEVEL = 6;

export const FONT_SIZES = [
  { pt: 7, name: 'S' },
  { pt: BODY_FONT_PT, name: 'M' },
  { pt: 11, name: 'L' },
  { pt: 13, name: 'XL' },
  { pt: 15, name: 'XXL' },
] as const;

export const MARKER_NUMBERINGS = ['1', 'a', 'A', 'i', 'I'] as const;
const MARKER_PUNCTUATIONS = ['dot', 'paren', 'parens'] as const;

type MarkerNumbering = (typeof MARKER_NUMBERINGS)[number];
type MarkerPunctuation = (typeof MARKER_PUNCTUATIONS)[number];
type MarkerFormat = `${MarkerPunctuation}-${MarkerNumbering}`;

export const isMarkerFormat = (value: string | null): value is MarkerFormat => {
  const [punctuation, numbering] = value?.split('-') ?? [];
  return (
    MARKER_PUNCTUATIONS.some((known) => known === punctuation) && MARKER_NUMBERINGS.some((known) => known === numbering)
  );
};

export const CLAUSE_ATTRIBUTE_NAMES = [
  ...Object.values(INDENT_ATTRS),
  ...Object.values(ORDERED_LIST_ATTRS),
  INDENT_FLAG_ATTR,
  LINE_SLOT_ATTR,
];

export const counterResetStyle = (start: number) => `counter-reset: item ${start - 1};`;

export const indentPaddingStyle = (levels: number) => `padding-left: ${levels * INDENT_EM_PER_LEVEL}em;`;
